/*
 * @Author: lidan
 * @Date: 2020-11-03 19:08:27
 * @LastEditTime: 2020-11-05 13:33:02
 * @LastEditors: lidan
 * @Description:车型管理api
 * @FilePath: \e6-module-base-data\src\e6-module-base-data\api\carModel.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_BASE_WEB = "",
  E6_MS_TMS_E6YUN_BASE_WEB = ""
} = e6ModuleBaseDataApi;

//********************* 车型管理 ****************** */

// 获取车型管理列表数据
export function findPageCarModel(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/carModel/findPage`,
    method: "post",
    data
  });
}

// 车型管理新增
export function saveCarModel(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/carModel/save`,
    method: "post",
    data
  });
}

// 根据ID查询车型
export function getByIdCarModel(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/carModel/findById`,
    method: "get",
    params
  });
}

// 车型管理修改
export function updateCarModel(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/carModel/update`,
    method: "post",
    data
  });
}

// 车型管理删除
export function deleteCarModel(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/carModel/delete`,
    method: "post",
    data
  });
}

// 车型管理导出
export function exportCarModel(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_BASE_WEB}/carModel/export`,
    method: "post",
    data
  });
}

// 车型管理导入
export function importCarModel(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/carModel/import`,
    method: "post",
    data
  });
}

// 车型管理历史记录
export function historyCarModel(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/carModel/findCarModelHistoryByPage`,
    method: "post",
    data
  });
}

// 车型管理名称唯一性校验
export function checkNameCarModel(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/carModel/checkName`,
    method: "get",
    params
  });
}

// 车型管理代码唯一性校验
export function checkCodeCarModel(params) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/carModel/checkCode`,
    method: "get",
    params
  });
}

// 货物类型数据
export function findByDicTypeKey(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/baseDictionary/findByDicTypeKey`,
    method: "get",
    params
  });
}
